<template>
  <div>
    <div class="header__order">
      <a class="header__item counter link link--base" href="#cart-dropdown" :data-counter="cntCartItems" data-fancybox-cart>
        <span class="counter__text">{{ title }}</span>
      </a>
    </div>
    <div class="cart-dropdown" id="cart-dropdown" data-custom-cursor=".custom-cursor">
      <div class="custom-cursor"></div>
      <div class="cart-dropdown__container">
        <div class="cart-dropdown__body" data-default-cursor>
          <div class="cart-dropdown__close"></div>
          <div v-if="cntCartItems" class="cart-dropdown__cont">
            <div v-for="(items, group) in groupedItems" :key="group" class="cart-dropdown__item">
              <div class="cart-dropdown__label">{{ group }}</div>
              <div class="cart-dropdown__list">
                <div class="cart-product" v-for="item in items" :key="item.id">
                  <div class="cart-product__img">
                    <picture v-if="item.img">
                      <img :src="item.img" alt="alt" loading="lazy">
                    </picture>

                    <img v-else src="/local/templates/xpage/img/catalog/product.svg" alt="Заглушка товара" loading="lazy">
                  </div>
                  <div class="cart-product__desc">
                    <span class="cart-product__name">{{ item.name }}</span>
                    <span class="cart-product__count">{{ item.quantity }} шт.</span>
                    <a v-if="item.link" class="cart-product__link" :href="item.link"></a>
                  </div>
                  <span class="cart-product__del" @click="removeFromCart(item.id)"></span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="cntCartItems" class="cart-dropdown__btns">
            <a class="default-btn default-btn--green" :href="siteDir + 'cart/'">
              {{ checkoutTitle }}
              <svg class="default-btn__icon" aria-hidden="true">
                <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
              </svg>
            </a>
          </div>
          <div v-if="!cntCartItems">{{ emptyTitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

export default {
  name: "CartSmall",
  props: {
    title: {
      type: [String],
      default: BX.message('CART_SMALL_TITLE')
    },
    checkoutTitle: {
      type: [String],
      default: BX.message('CART_SMALL_CHECKOUT')
    },
    emptyTitle: {
      type: [String],
      default: BX.message('CART_SMALL_EMPTY')
    },
    siteDir: {
      type: [String],
      default: '/'
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('moduleCart', {
      cntCartItems: 'cntItems',
      cartItems: 'allItems'
    }),
    groupedItems: function () {
      let map = this.cartItems.reduce((r, i) => {
        r[i.group] = r[i.group] || [];
        r[i.group].push(i);
        return r;
      }, {});
      return map;
    }
  },
  methods: {
    ...mapActions('moduleCart', {
      removeFromCart: 'remove'
    }),
  }
}
</script>